module.exports = __webpack_public_path__ + "img/video.6149b60f.jpg";